import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const trustSafetyPrinciples = [
    {
        title: 'Ethical AI Development',
        description: 'We ensure that our AI models follow ethical guidelines and do not promote bias or misinformation.',
    },
    {
        title: 'Data Privacy & Security',
        description: 'User data is encrypted and protected using industry-leading security standards.',
    },
    {
        title: 'Fairness & Transparency',
        description: 'We strive to make our AI models fair, accountable, and explainable.',
    },
    {
        title: 'Content Moderation',
        description: 'We monitor and filter content to ensure a safe and professional learning environment.',
    },
    {
        title: 'User Safety & Well-being',
        description: 'Our platform prioritizes user well-being through strict policies on harassment and cyber threats.',
    },
    {
        title: 'AI Bias & Auditing',
        description: 'We regularly audit our AI systems to identify and reduce potential biases.',
    },
    {
        title: 'Cybersecurity Best Practices',
        description: 'We implement security measures to protect against cyber threats and unauthorized access.',
    },
    {
        title: 'Responsible AI Governance',
        description: 'Our AI follows responsible governance policies to align with ethical standards and regulations.',
    },
];

function AITrustSafety() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>AI Trust & Safety</Title>
                <Paragraph>
                    At JectHub, we are committed to building AI solutions that are safe, ethical, and secure. Below are the principles that guide our AI trust and safety initiatives.
                </Paragraph>
                <Row gutter={[16, 16]}>
                    {trustSafetyPrinciples.slice(0, 4).map((principle, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={principle.title} bordered={false}>
                                <Paragraph>{principle.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <hr style={{ margin: '40px 0' }} />
                <Row gutter={[16, 16]}>
                    {trustSafetyPrinciples.slice(4, 8).map((principle, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={principle.title} bordered={false}>
                                <Paragraph>{principle.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default AITrustSafety;
